import React, { useEffect, useState } from "react";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Card from "../../components/Card";
import { IoSearchOutline } from "react-icons/io5";
import Pagination from "../../components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { getUsersByType } from "../../redux/actions/typeAction";
import ListeLoader from "../../components/loader/listeLoader";
import createSlug from "../../utils/slug";
import { useDebounce } from "../../utils/useDebounce";
import ServerErrorPage from "../Hatalar/ServerErrorPage";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  return isMobile;
};

const Liste = ({ page }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchUser, setSearchUser] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const { users, loading, error, pagination } = useSelector(
    (state) => state.users
  );
  const [allUsers, setAllUsers] = useState([]);

  const currentPage = parseInt(searchParams.get("page")) || 1;
  const isMobile = useIsMobile();
  const limit = isMobile ? 10 : 20;

  // Debounce search input
  const debouncedSearchUser = useDebounce(searchUser, 400);

  useEffect(() => {
    if (page) {
      dispatch(getUsersByType({ userType: page, page: 1, limit: 1000 }))
        .unwrap()
        .then((response) => {
          setAllUsers(response.data || []);
        })
        .catch((error) => {
          console.error("Veri yüklenirken hata oluştu:", error);
          // Redux store'daki error state'i zaten set edilmiş olacak
        });
    }
  }, [dispatch, page]);

  const handlePageChange = (selectedPage) => {
    setSearchParams({ page: selectedPage });
    window.scrollTo(0, 0);
  };

  const filteredUsers = allUsers.filter(
    (user) =>
      user.name.toLowerCase().includes(debouncedSearchUser.toLowerCase()) ||
      user.position.name
        .toLowerCase()
        .includes(debouncedSearchUser.toLowerCase())
  );

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );

  const totalPages = Math.ceil(filteredUsers.length / limit);

  if (loading) return <ListeLoader />;
  if (error) return <ServerErrorPage />;
  if (!allUsers.length) {
    return (
      <div className="containerMain flex flex-col items-center justify-center min-h-[90vh] gap-4">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-grayy mb-2">
            {page === "junior" ? "Junior" : "Senior"} bulunamadı
          </h2>
          <p className="text-grayy">
            Şu anda {page === "junior" ? "junior" : "senior"} kullanıcısı
            bulunmuyor.
          </p>
        </div>
        <Link to="/" className="btn-dark text-white text-sm">
          Ana Sayfaya Dön
        </Link>
      </div>
    );
  }

  return (
    <div className="containerMain flex flex-col gap-8 min-h-[90vh]">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="baslik flex flex-col gap-4">
          <h1 className="text-2xl font-bold">
            {page === "junior" ? "Juniorlar" : "Seniorlar"} (
            {filteredUsers.length})
          </h1>
          <div className="text-sm text-grayy flex items-center gap-2 font-medium">
            <IoHomeOutline className="w-4 h-4" />
            <Link to="/">Anasayfa</Link>
            <MdOutlineKeyboardArrowRight className="w-6 h-6" />
            <span className="text-darkerGreen">
              {page === "junior" ? "Juniorlar" : "Seniorlar"}
            </span>
          </div>
        </div>
        <div className="arama flex items-center border-2 border-lineGray rounded-2xl w-[318px] h-[48px] p-4 gap-4 custom-input">
          <button>
            <IoSearchOutline className="size-6" />
          </button>
          <input
            type="text"
            className="border-none outline-none w-full py-2 placeholder:truncate overflow-hidden bg-white"
            placeholder="isim, ünvan ara"
            value={searchUser}
            onChange={(e) => {
              setSearchUser(e.target.value);
              setSearchParams({ page: 1 });
            }}
          />
        </div>
      </div>
      <div className="container liste grid grid-cols-1 place-items-center sm:grid-cols-2 lg:grid-cols-3 gap-4 xl:grid-cols-4">
        {paginatedUsers.map((user) => (
          <Link
            key={user.id}
            className="block w-full"
            to={`/${page}/${createSlug(user.name)}`}
            state={{ userId: user.id }}
          >
            <Card user={user} />
          </Link>
        ))}
      </div>
      <div className="flex justify-end">
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Liste;
